<template>

  <md-dialog :md-active.sync="showEditRowDialog" v-on:md-clicked-outside="onCancelEditRow()">
    <md-dialog-title v-show="currentRow.id !== 0">Modifica</md-dialog-title>
    <md-dialog-title v-show="currentRow.id === 0">Nuova</md-dialog-title>
    <md-dialog-content>
      <md-vuelidated>
        <label for="pos">Pos</label>
        <md-input type="text" v-model="pos" />
        <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
      </md-vuelidated>
      <md-vuelidated>
        <label for="row">Material number (SAP)</label>
        <md-input type="text" v-model="materialNumber" />
        <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
      </md-vuelidated>
      <div class="minwidth300">
        <md-vuelidated>
          <label for="description">Description</label>
          <md-input type="text" v-model="description" />
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
      </div>
      <div class="field-wrapper">
        <md-vuelidated>
          <label for="pcsUnit">Pieces</label>
          <md-input type="text" v-model="pcsUnitQuantity" />
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
        <md-vuelidated>
          <md-select v-model="pcsUnitUnit">
            <md-option value="PAL">PAL</md-option>
            <md-option value="PC">PC</md-option>
          </md-select>
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
      </div>
      <div class="field-wrapper">
        <md-vuelidated>
          <label for="packagingAmount">Packaging Amount</label>
          <md-input type="text" v-model="packagingAmountQuantity" />
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
        <md-vuelidated>
          <md-select v-model="packagingAmountUnit">
            <md-option value="PAL">PAL</md-option>
            <md-option value="PC">PC</md-option>
          </md-select>
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
      </div>
      <div class="field-wrapper">
        <md-vuelidated>
          <label for="quantity">Quantity</label>
          <md-input type="text" v-model="quantityQuantity" />
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
        <md-vuelidated>
          <md-select v-model="quantityUnit">
            <md-option value="PAL">PAL</md-option>
            <md-option value="PC">PC</md-option>
          </md-select>
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
      </div>
      <div class="field-wrapper">
        <md-vuelidated>
          <label for="weight">Weight</label>
          <md-input type="text" v-model="weightQuantity" />
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
        <md-vuelidated>
          <md-select v-model="weightUnit">
            <md-option value="KG">KG</md-option>
          </md-select>
          <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
        </md-vuelidated>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-raised" @click="onConfirmEditRow()">Conferma</md-button>
      <md-button class="md-primary" @click="onCancelEditRow()">Annulla</md-button>
    </md-dialog-actions>
  </md-dialog>

</template>
<script>

  import { validationMixin } from 'vuelidate'
  import { required, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    name: 'CaricoRowEdit',
    mixins: [validationMixin],
    props: ['showEditRowDialog', 'currentRow'],
    validations: {
      pos: {
        required
      },
      materialNumber: {
        required
      },
      description: {
        required
      },
      pcsUnitQuantity: {
        required
      },
      pcsUnitUnit: {
        required
      },
      packagingAmountQuantity: {
        required
      },
      packagingAmountUnit: {
        required
      },
      quantityQuantity: {
        required
      },
      quantityUnit: {
        required
      },
      weightQuantity: {
        required
      },
      weightUnit: {
        required
      }
    },
    computed: {
      pos: {
        get() {
          return this.currentRow.pos
        },
        set(val) {
          this.currentRow.pos = val
        }
      },
      materialNumber: {
        get() {
          return this.currentRow.materialNumber
        },
        set(val) {
          this.currentRow.materialNumber = val
        }
      },
      description: {
        get() {
          return this.currentRow.description
        },
        set(val) {
          this.currentRow.description = val
        }
      },
      pcsUnitQuantity: {
        get() {
          return this.currentRow.pcsUnitQuantity
        },
        set(val) {
          this.currentRow.pcsUnitQuantity = val
        }
      },
      pcsUnitUnit: {
        get() {
          return this.currentRow.pcsUnitUnit
        },
        set(val) {
          this.currentRow.pcsUnitUnit = val
        }
      },
      packagingAmountQuantity: {
        get() {
          return this.currentRow.packagingAmountQuantity
        },
        set(val) {
          this.currentRow.packagingAmountQuantity = val
        }
      },
      packagingAmountUnit: {
        get() {
          return this.currentRow.packagingAmountUnit
        },
        set(val) {
          this.currentRow.packagingAmountUnit = val
        }
      },
      quantityQuantity: {
        get() {
          return this.currentRow.quantityQuantity
        },
        set(val) {
          this.currentRow.quantityQuantity = val
        }
      },
      quantityUnit: {
        get() {
          return this.currentRow.quantityUnit
        },
        set(val) {
          this.currentRow.quantityUnit = val
        }
      },
      weightQuantity: {
        get() {
          return this.currentRow.weightQuantity
        },
        set(val) {
          this.currentRow.weightQuantity = val
        }
      },
      weightUnit: {
        get() {
          return this.currentRow.weightUnit
        },
        set(val) {
          this.currentRow.weightUnit = val
        }
      }
    },
    methods: {
      onConfirmEditRow() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        var values = {
          id: this.currentRow.id,
          pos: this.pos,
          materialNumber: this.materialNumber,
          description: this.description,
          pcsUnit: {
            quantity: this.pcsUnitQuantity,
            unit: this.pcsUnitUnit
          },
          packagingAmount: {
            quantity: this.packagingAmountQuantity,
            unit: this.packagingAmountUnit
          },
          quantity: {
            quantity: this.quantityQuantity,
            unit: this.quantityUnit
          },
          weight: {
            quantity: this.weightQuantity,
            unit: this.weightUnit
          }
        }
        this.$v.$reset()
        this.$emit('save-row', values)
      },
      onCancelEditRow() {
        this.$v.$reset()
        this.$emit('close-edit')
      }
    }
  }

</script>

<style>

  .desc {
    max-width: 320px;
  }
  .sscc > td {
    border-top: 0px !important;
  }
  .ssccList {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .ssccNumber {
    max-width: 150px;
    width: 150px;
    text-align: left;
  }
  .md-field .md-error {
    display: block !important;
    left: 0;
    opacity: 0;
    transform: translate3d(0, -8px, 0);
  }
  .md-field .md-count,
  .md-field .md-error,
  .md-field .md-helper-text {
    height: 20px;
    position: absolute;
    bottom: -22px;
    font-size: 12px;
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md-field.md-invalid .md-error {
    opacity: 1;
    transform: translateZ(0);
  }
  .md-invalid .md-error,
  .md-invalid label {
    color: #ff1744;
  }
  .field-wrapper {
    display: flex;
    max-width: 220px;
    width: 100%;
    justify-content: space-between;
  }
  .field-wrapper > .md-field:first-child {
    max-width: 65%;
  }
  .field-wrapper > .md-field:last-child {
    max-width: 25%;
  }

</style>



// WEBPACK FOOTER //
// src/components/CaricoRowEdit.vue